module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-003"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Illustration",
      "id": "chap2",
      "src": "images/chap2.jpg"
    }
  })])]), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("OPEN YOURSELF TO AWE"), _c('br'), _vm._v("AND WONDER")])]), _c('div', {
    staticClass: "exergues"
  }, [_c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("How delightful it is")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("to live in a place of beauty,")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("to share the joy of life")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("with the great I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AM")]), _vm._v(".")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("How delightful it is")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("to see the birds hovering overhead,")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("and hear the whispering wind")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("rustling through the trees.")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("I breathe in the rhythm of God’s world,")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("the ebb and flow of seasons,")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("the fading of day’s bright light")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("into night’s embrace.")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("I dance for joy")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("surrounded by God’s grandeur")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("and open my senses to wonder and awe.")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("I sit content in the glory of God’s embrace")])]), _c('p', {
    staticClass: "txt_courant_centre last"
  }, [_c('i', [_vm._v("and absorb the fragrance of God’s loving presence.")])])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The 2017 solar eclipse was an awe-inspiring event in Seattle, and I was caught up in the thrill and excitement of it. I watched as the sky darkened to blue and then black. Crescent-shaped sunspots danced under the trees, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  }, [_vm._v("slowly narrowing until they disappeared into the darkness. I squinted through my eclipse glasses awed by the same diminishing crescent of light that was the sun slipping behind the moon. An eerie silence fell over the neighborhood. Then a small sliver of light reappeared, growing until the sun once more shone as a magnificent golden orb. Kids danced. Their parents cheered. We all burst into tears and hugged each other.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("There was something both unsettling and exhilarating about it. We were overcome by the feeling of being part of something immense, beautiful, and much bigger than ourselves. It didn’t just hit our eyes with its wonder; it penetrated our souls and pierced deep into our spirits.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It is sad that it takes a rare event like this to awaken awe and wonder in us. So much of what seems miraculous to a child, adults try to explain away with rational, scientific knowledge, often destroying the mystery, awe, and wonder in the process. We no longer dance and sing exuberantly before God like David did, but are more inclined to react like his David’s wife, Micah, who, as so often happens with those who no longer live in the world of awe and wonder, despises his demonstrative joy (2 Samuel 6:16).")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Wonder is a beautiful gift from God. Magical, awe-inspiring feelings change our approach to life.")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Awe imbues people with a different sense of themselves, one that is smaller, more humble and part of something larger. Our research finds that even brief experiences of awe, such as being amid beautiful tall trees, lead people to feel less narcissistic and entitled and more attuned to the common humanity people share with one another. In the great balancing act of our social lives, between the gratification of self-interest and a concern for others, fleeting experiences of awe redefine the self in terms of the collective, and orient our actions toward the needs of those around us."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-023",
      "id": "ap_ntf-023-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Father Greg Boyle, in "), _c('i', [_vm._v("Barking to the Choir")]), _vm._v(", suggests it isn’t just nature that gives us this sense of awe. We can embrace the marginalized with a sense of awe too. He comments beautifully: “Awe softens us for the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_vm._v("thunder glance of God, then enables us to glance at others in just the same way.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-024",
      "id": "ap_ntf-024-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Unfortunately, the research also suggests that we are awe-deprived. We sit behind computers, not beside trees. We rarely visit art galleries, live music, theater, and museums. Even schools are dismantling their arts and music programs. Unfettered time outdoors is being cut for more résumé-building activities. Our bodies, our faith, and our concern for others all suffer as a result. Some of the leading researchers looking at this subject believe that “awe deprivation has had a hand in a broad societal shift” making us “more individualistic, more self-focused, more materialistic and less connected to others.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-025",
      "id": "ap_ntf-025-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" To reverse this trend, they suggest that we all need to experience more everyday awe, and actively look for and take notice of what gives us goose bumps, be it in looking at trees, night skies, cloud patterns, or children playing.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The Bible is full of childlike awe and wonder. We see it in Moses as he praises the great Creator of the universe in his goose bump producing song in Deuteronomy 10:14, 17:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("To the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" your God belong the heavens, even the highest heavens, the earth and everything in it. . . . For the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" your God is the God of gods and Lord of lords, the great God, mighty and awesome, who shows no partiality and cannot be bribed. (NIV)")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("We hear it in David’s exclamation of praise of creation in Psalm 65:8:")]), _c('div', {
    staticClass: "stroplg"
  }, [_c('p', {
    staticClass: "verslg"
  }, [_vm._v("The whole earth is filled with awe at your wonders;")]), _c('p', {
    staticClass: "verslg"
  }, [_c('span', {
    staticClass: "tabulation"
  }, [_vm._v("where morning dawns, where evening fades,")])]), _c('p', {
    staticClass: "verslg"
  }, [_c('span', {
    staticClass: "tabulation"
  }, [_vm._v("you call forth songs of joy.")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("I suspect it as also this type of awe and wonder that had him dancing before God as he helped return the ark of the covenant to Jerusalem ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=2%20Samuel+6%3A14&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("2 Samuel 6:14")]), _vm._v(").")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Jesus too lived in the world of joyful, childlike awe and mystery. We sense it in his zest for life and the wonderful way he communicates "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "title": "26"
    }
  }, [_vm._v("with God, inspiring his disciples to crave new joy-filled ways to pray. We see it in Jesus’ enthusiasm for creation and his encouragement to his followers to go out and look closely at the birds and think about the wild lilies ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Luke+12%3A27&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("Luke 12:27")]), _vm._v("). We experience it in his embrace of kids, enjoyment of meals, and passion for healing and wholeness. Our daily experience of life, God, and God’s world are meant to inspire us with the awe and wonder of childhood.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("According to John Pridmore in his fascinating book "), _c('i', [_vm._v("Playing with Icons: The Spirituality of Recalled Childhood")]), _vm._v(", in which he analyzes a rich variety of people’s memories of their childhoods, our decline in capacity to notice the miracles around us as we grow older is “a failure of the spirit as well as the senses.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-026",
      "id": "ap_ntf-026-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" He argues that by the time we become adults we lose our child’s eye and no longer experience everyday objects with all our senses or capture them in their true light because they are now familiar and commonplace. It takes a rare event like a solar eclipse to stir within us the spirit-touching awe and wonder kids experience every day.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Pridmore points out that when Jesus drives out the traders and money changers in the temple, then heals the blind and the lame, the authorities get angry but the children sing and dance because “for Jesus it is the children alone who see the significance of the "), _c('i', [_vm._v("thaumasia")]), _vm._v(", the wonderful things he is doing.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-027",
      "id": "ap_ntf-027-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Jesus reminds the authorities that “out of the mouths of infants and nursing babies you have prepared praise” ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Matthew+21%3A16&version=ESV",
      "target": "_blank"
    }
  }, [_vm._v("Matthew 21:16")]), _vm._v(" ESV).")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Rings of children circled round and sang, ‘Hosanna to the Son of David’” ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Matthew+21%3A15&version=ESV",
      "target": "_blank"
    }
  }, [_vm._v("Matthew 21:15")]), _vm._v("). The children alone recognized the wonder of what he did. Have you ever noticed that? If you say no you are not alone. No one else I mentioned this to has either. Not only have we lost our ability to appreciate awe and wonder, we no longer notice those, especially the children, who do.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In our awe-deprived lives, I suspect we also miss the awesome significance of the gift of loaves and fishes from a small boy to feed "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "title": "27"
    }
  }, [_vm._v("thousands ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=John+6%3A8-10&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("John 6:8-10")]), _vm._v("). The disciples are overwhelmed with the impossible burden of providing food when there is none. They have no room for miracles. I wonder, did the children come as a crowd with their little friend and his gift eager to see what Jesus would do? Did they cheer and jump with excitement while their parents tried to push them away and keep them quiet? Only the children truly saw the wonder of who Jesus was and believed he could perform a miracle to feed all of them with this meager offering.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In my early days on board the MV "), _c('i', [_vm._v("Anastasis")]), _vm._v(" I had a similar experience. We were stuck in Greece trying to resurrect this old ship, with very little money and fewer resources. During a forty-day fast to seek God’s guidance for the future, we met each morning for prayer in a room that looked out over the Mediterranean Sea.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("One day toward the end of our fast we looked outside and noticed silver streaks flashing in the sunlight. “The fish are jumping” someone called, and we raced outside. Fish were jumping out of the sea and stranding themselves on the beach. We grabbed pots and pans and wheelbarrows, excitedly collecting 8,301 fish flapping furiously as they gasped for air. We danced, we sang, and we exalted like kids in the God who had provided in this unexpected and awe-inspiring way.")]), _c('div', {
    staticClass: "encsansfilet",
    attrs: {
      "id": "enc-005"
    }
  }, [_c('div', {
    staticClass: "dev"
  }, [_c('figure', {
    staticClass: "fighaut",
    attrs: {
      "id": "carre22"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration",
      "src": "images/carre.jpg"
    }
  })])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When was the last time you experienced a sense of wonder at the world around you or sat in awe of God’s greatness?")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When was the last time you experienced a sense of wonder at the world around you or sat in awe of God’s greatness? When was the last time you jumped with excitement and shouted your praises to God, believing that God still performs miracles of provision and healing? Perhaps it is time to reenter the awe-inspiring world of childhood where everything is a miracle. Maybe it is time to rethink our spiritual practices to make this possible.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "title": "28"
    }
  }, [_vm._v("The first key to recovering awe and wonder is to allow for silence. Not the silence that comes from an absence of noise but "), _c('i', [_vm._v("silentium")]), _vm._v(", the silence of attentiveness toward God. Only "), _c('i', [_vm._v("silentium ")]), _vm._v("provides a quiet space for our souls, allows our imaginations to flourish, and opens us to awe of our amazing God. This form of quietness is not easy to find because it isn’t about place but attitude. "), _c('i', [_vm._v("Silentium")]), _vm._v(" encourages us to slow down, set aside the distractions of minds, hearts, and daily activities to draw from the quiet inner center to commune with the spirit of God in a special way.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-006"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("ENTER THE SILENCE")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The contemplative practice of lectio divina with its invitation to this kind of listening silence opened my soul to awe and wonder once more. "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-003"
    }
  }, [_vm._v("Lectio divina is an ancient prayer technique once widespread in Christian practice. Its popularity is increasing once again as practitioners find it unveils underlying spiritual rhythms in daily life.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-003"
    }
  }, [_vm._v("In her book "), _c('i', [_vm._v("Lectio Divina: The Sacred Art")]), _vm._v(", which is the most helpful book I have read on lectio divina, Benedictine oblate Christine Valters Paintner describes lectio as “a practice of being present to each moment in a heart-centered way. Our memories, images, and feelings become an important context for experiencing God’s voice active in us, and we discover it when we pray from our hearts. Those words moving through us break open God’s invitation to us in this moment of our lives and call us to respond.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-028",
      "id": "ap_ntf-028-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Lectio invites us to shut out the distractions of inner and outer noise and sit quietly in the presence of God. It encourages us to relish and savor not just the meaning of the verses we read but also the new and inspiring revelations of God they bring to our days. I love the way that it invites us to center ourselves on God and listen contemplatively for what God’s Spirit might say.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("There are four movements to lectio divina that take fifteen to thirty minutes to complete.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "title": "29"
    }
  }, [_vm._v("We begin with "), _c('i', [_vm._v("lectio")]), _vm._v(", a reverential listening in a spirit of silence and awe. Settle into your prayer space, let go of your distractions, and open yourself to the mystery of prayer. Read through your Bible verse slowly several times, attentively and gently listening for a word or phrase that stands out or, as Paintner describes it, “shimmers” as God’s word for you today.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In the second movement, "), _c('i', [_vm._v("meditatio")]), _vm._v(", we welcome what stirs as a form of inner hospitality. This is where we speak with God and allow God’s Word to affect us at our deepest levels. We")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("move the words into [our] heart and allow them to be broken open. . . . When we enter into the wide open space of our hearts and imaginations, we give room for connections to emerge, to notice the resonances this word or phrase has with our own experience. There is a spirit of playfulness that is set free as we enter into the text with openness. When we “play” with the words, we allow ourselves to stretch beyond our own assumptions and rules about what something means."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-029",
      "id": "ap_ntf-029-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Read the text again and savor the word or phrase that caught your attention. Allow it to unfold in your imagination. Savor it. What memories, feelings, sensations, and images does it evoke? Perhaps a special meal, with all its flavors, aromas, and joyful celebration comes to mind. How does the text interact with your inner world of concerns and ideas?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In the third movement, "), _c('i', [_vm._v("oratio")]), _vm._v(", we respond in ways that connect the passage to our everyday lives. The intimacy of opening our hearts to God and listening for what stirs within us encourages us to be more active and engaged in our world. We share God’s ache for a hurting world. We rejoice in God’s delight in the beauty of creation. Prayer bubbles up spontaneously from within and awe and wonder emerge as our hearts are touched and God draws close. It’s intoxicating and exciting to converse with God in this way, knowing the Eternal One invites us into a loving embrace.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "title": "30"
    }
  }, [_vm._v("How is God prompting you to respond as you connect to your passage? Offer to give God your thoughts and reflections, and invite God to use the Scripture to change you.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The fourth stage is "), _c('i', [_vm._v("contemplatio")]), _vm._v(". Now is the time to slow your breathing, sit still, and rest in the presence of God. Free yourself from your own thoughts, let go of your own words and open your mind, heart, and soul to hear God speak. Enjoy the awe-inspiring experience of being in the presence of God. Do you sense that warm embrace around you? Do you see God’s tears and touch God’s pain? Are you grateful for God’s loving presence? Offer appropriate prayers to God. Enjoy what God is doing and saying to you. Sit and think about a response. Is there a prayer or a song bubbling up inside you? Are you prompted to journal or create an image? Allow God’s presence to flow uninhibited through you.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Practicing lectio divina encouraged me to listen more attentively not just to Scripture but also to my life and to the world I live in. It empowered me to get out into nature and walk around my neighborhood with a different perspective, truly looking, listening, tasting, touching, and smelling in a way I had not done before. It opened my eyes to the wonder of all God’s creation.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("There are many ways that this kind of reflective approach opens us to the awe and wonder of God’s world. All we need to do is get out, walk, and take notice.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We all know that walking benefits our physical health. Like many of us, I have been caught up in the passion for Fitbit steps. Evidently, ten thousand steps a day reduces the risk of heart disease, colon cancer, and stroke; lowers blood pressure; controls weight; increases bone density; and helps prevent osteoporosis and much more.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Walking is great for our spiritual well-being too. It is the fastest pace for noticing something enough to truly see it and appreciate it fully, not just with our eyes but with all our senses in the way that children do. Not walking as in stair climbing but walking as in getting "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "title": "31"
    }
  }, [_vm._v("out to explore our neighborhoods with the intent to observe, learn, and interact. Walking is not meant to be done fast or alone. It is a form of noticing that is best done in company with others.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("God’s created world is my favorite place for walking. It is the ultimate arena of awe, inspiring all of us to think, question, form new ideas, and become creative. We can draw in the dirt like Jesus did, examine the wildflowers as he encouraged his followers to do, make designs with leaves, build forts with blankets, or just lie on the ground and admire the clouds. Nature is ever changing and inspirational. There is always something new to explore, create, and get excited about.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Tom and I now call our daily lakeside walks awe-and-wonder walks. We deliberately notice and point out to each other the inspiring sights of early morning light reflected in the lake, birds hovering in the sky and leaves slowly changing with the seasons. Walking our dog, we notice our neighborhood with the same awe. This garden is well kept with beautiful flowers in every season. That one is drab and neglected. We greet our neighbors and share stories about gardens and pets.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("If we wander around the city, we notice and point out the urban lots transformed into community garden plots, the new skyscrapers rising into the sky, and the homeless people asleep in the doorways. We are enticed by the smell of coffee and baked goods from the cafe on the corner and enjoy the delight of making new friends. It is fun, and as we walk we often sense an "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-004"
    }
  }, [_vm._v("awe-and-wonder song well up within us.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-004"
    }
  }, [_vm._v("It’s a little like the disciples on the Emmaus road. They walked and talked. They were excited by the rumors of Jesus’ resurrection. Awe and wonder bubbled up within them. Suddenly Jesus was walking with them (")]), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Luke+24%3A14-15&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("Luke 24:14-15")]), _vm._v("). The exhilaration of sharing as we do when we walk and talk with others often brings Jesus into our midst explaining the Scriptures and how they reveal who he is. I wonder if that was the case for the disciples on the Emmaus road.")]), _c('div', {
    staticClass: "encsansfilet",
    attrs: {
      "id": "enc-006"
    }
  }, [_c('div', {
    staticClass: "dev"
  }, [_c('figure', {
    staticClass: "fighaut",
    attrs: {
      "id": "carre"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration",
      "src": "images/carre.jpg"
    }
  })])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("How would it change your life and faith if you took regular awe-and-wonder walks?")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "title": "32"
    }
  }, [_vm._v("One beautiful walking practice created by St. John Providence Health System parish nursing in Michigan is “A Walk to Jerusalem” and “A Walk to Bethlehem.” The idea is to improve the physical, emotional, and spiritual health of participants by taking imaginary trips to Jerusalem before Easter or to Bethlehem before Christmas."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-030",
      "id": "ap_ntf-030-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Participants log their walking miles each week. Hopefully, by the time Easter arrives the total miles walked by all members of a church group will equal the number of miles to Jerusalem. Devotionals, prayers, and cultural information on the countries passed through provide wonderful resources to make this a fun and inspirational spiritual practice. These resources don’t just talk about culture but also address societal needs participants would encounter if they actually walked to Jerusalem. For example, when they walk through the waters of the Atlantic, reflections focus on water scarcity, pollution, and sanitation.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Walking is for noticing not just sights, sounds, and smells but God, neighbors, and friends. How would it change your life and faith if you took regular awe-and-wonder walks? Why not try it? Go out and have a good walk today, notice your neighborhood, enjoy its sounds and smells and sights. Anchor yourself and find where you belong. Refresh your spirit and your soul. Come home and journal about what you experienced.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-007"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("A NEW WAY OF SEEING")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Walking a dog or admiring other people’s gardens may not appeal to you, but there are other ways your noticing skills can enrich your spiritual life and open you to the awe and wonder of God’s world. "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-005"
    }
  }, [_c('i', [_vm._v("Visio divina")]), _vm._v(" or praying with art is becoming increasingly popular, not surprising in a world as visually oriented as ours. Orthodox Christians have long used icons to pray, but it is only recently that visio "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "title": "33"
    }
  }, [_vm._v("divina has become popular among Protestants. Religious art, street murals, photographs, and even graffiti can all provide inspiration for this practice.")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-005"
    }
  }, [_vm._v("Visio divina is similar to lectio divina but relies on images rather than words. It invites us to fully enter into an image, to take time to see deeply beyond first and second impressions. It inspires us to be transformed by new interpretations that God speaks through.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-005"
    }
  }, [_vm._v("Choose an image, and take a slow look at it. Drink in the figures, colors, textures, and shapes. What draws your attention? Sit with your initial thoughts and feelings for a few minutes. Return to the image several times with an open heart and mind. Something new is likely to draw your attention each time. New thoughts, meanings, and feelings will arise. Your initial impressions should expand and deepen, allowing you to explore the image in fresh ways.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-005"
    }
  }, [_vm._v("Prayerfully ponder your responses. What do you think the Spirit might want to reveal as you look and listen in quiet meditation to the feelings, thoughts, desires, and meanings evoked? Finish with prayer, taking time to respond to God with gratitude, supplication, wonder, lament, song, dance, or praise. Jot down responses in your journal as a reminder of the God-inspired awe the image awakened. Close by resting in God’s grace and love.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-005"
    }
  }, [_vm._v("The Book of Kells, an ancient illustrated Gospels manuscript with powerful images of saints and animals and beautiful calligraphy done by Celtic monks probably in the ninth century, is my favorite go to resource for visio divina.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-031",
      "id": "ap_ntf-031-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" The more recent St. John’s Bible, a hand-written, hand-illuminated Bible created by renowned calligrapher Donald Jackson, also provides wonderful illustrations to contemplate."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-032",
      "id": "ap_ntf-032-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Alternatively, you might like to visit your local art gallery and sit in front of a painting that catches your attention. Or use an image of your favorite painting or neighborhood street art.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A couple of years ago Tom and I had the privilege of walking around San Francisco with author and speaker Mark Scandrette. San "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "title": "34"
    }
  }, [_vm._v("Francisco is one of our favorite cities. Tom spent much of his childhood there, and it is always a delight to return and walk the streets.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This time, however, Mark gave us a new visio divina way to view those streets, which inspired me with awe and wonder in places I had never imagined. He walked us through Balmy Alley, where murals first appeared in the mid-1980s in response to human rights and political abuses in Central America."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-033",
      "id": "ap_ntf-033-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" The murals grew to include human rights violations, gentrification, and Hurricane Katrina. We walked past life-size images of weeping women, rioting crowds, and massacred resisters. Among them, Christ dying in agony on the cross seared the images of pain, suffering, and liberation into my brain. I was stunned, awed, and humbled by people who endured so much. I was challenged to do something to prevent similar injustices in the future. This is one of Mark’s favorite places to walk and reflect. I understand why.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("For some, the new way of seeing is through the lens of a camera. Photography has blossomed as an art over the last few years. Everyone is taking and sharing pictures. Evidently, over four thousand are taken every second in the United States alone.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The moment we give close attention to anything, as the lens of a camera invites us to do, even a leaf dancing in the wind or an insect hovering over a flower can become awe inspiring, reminding us that we live in a world of wonder and mystery.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I have always loved photography, but it was Christine Valters Paintner who helped me interpret this joy as a special awe-inspiring encounter with God.")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Look through the lens and imagine that it is a portal to a new way of seeing. Let the focus of the frame bring your gaze to the quality of light in this moment or the vibrancy of colors. Like in the film "), _c('i', [_vm._v("American Beauty")]), _vm._v(", let yourself be willing to see the world differently, so that what others see as garbage becomes "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35",
      "title": "35"
    }
  }, [_vm._v("transfigured through your openness and intention. This isn’t always easy, and ultimately it is God’s work in us; we just create the right conditions to receive the gift."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-034",
      "id": "ap_ntf-034-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Not only has the lens become a portal to a new way of seeing for me, but my view of all images has gained the same holy revelation, bringing me an incredible amount of joy and a reawakening of awe in the process. I often stop to take a second look at everything from street signs to cracks in the road. Sometimes I do click a photo for future meditation. Sometimes I just pause for a moment of awe and wonder.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d40e346","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap3.vue
// module id = 75
// module chunks = 0